import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/margin-requirement',
  component: () => import('../../routes/PortfolioMargin.svelte'),
  card: {
    id: 'margin-requirement',
    title: 'Margin Requirement',
    description: 'Calculate margin requirements, equity, and margin call risk for your stock portfolio.',
    icon: 'account_balance',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/margin-requirement',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Portfolio Margin Requirement Calculator – Margin Call & Equity Calculator',
    description: 'Free portfolio margin calculator. Calculate margin requirements, equity, available margin, and margin call risk for your stock portfolio. Enter multiple positions with market values and margin percentages to see your account status instantly.',
  },
};

export default meta;
